import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isHex, isU8a, u8aConcat, u8aToU8a } from '@polkadot/util';
import { AbstractArray } from "./AbstractArray.mjs";
import { decodeU8a, mapToTypeMap, typeToConstructor } from "./utils/index.mjs";
/** @internal */

function decodeTuple(registry, _Types, value) {
  if (isU8a(value) || isHex(value)) {
    return decodeU8a(registry, u8aToU8a(value), _Types);
  }

  var Types = Array.isArray(_Types) ? _Types : Object.values(_Types);
  return Types.map(function (Type, index) {
    try {
      var entry = value === null || value === void 0 ? void 0 : value[index];

      if (entry instanceof Type) {
        return entry;
      }

      return new Type(registry, entry);
    } catch (error) {
      throw new Error("Tuple: failed on ".concat(index, ":: ").concat(error.message));
    }
  });
}
/**
 * @name Tuple
 * @description
 * A Tuple defines an anonymous fixed-length array, where each element has its
 * own type. It extends the base JS `Array` object.
 */


export var Tuple =
/*#__PURE__*/
function (_AbstractArray) {
  _inherits(Tuple, _AbstractArray);

  function Tuple(registry, Types, value) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tuple);

    var Clazzes = Array.isArray(Types) ? Types.map(function (type) {
      return typeToConstructor(registry, type);
    }) : mapToTypeMap(registry, Types);
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tuple)).call.apply(_getPrototypeOf2, [this, registry].concat(_toConsumableArray(decodeTuple(registry, Clazzes, value)))));
    _this._Types = void 0;
    _this._Types = Clazzes;
    return _this;
  }

  _createClass(Tuple, [{
    key: "toRawType",

    /**
     * @description Returns the base runtime type name for this instance
     */
    value: function toRawType() {
      var _this2 = this;

      var types = (Array.isArray(this._Types) ? this._Types : Object.values(this._Types)).map(function (Type) {
        return _this2.registry.getClassName(Type) || new Type(_this2.registry).toRawType();
      });
      return "(".concat(types.join(','), ")");
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      // Overwrite the default toString representation of Array.
      return JSON.stringify(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      return u8aConcat.apply(void 0, _toConsumableArray(this.map(function (entry) {
        return entry.toU8a(isBare);
      })));
    }
  }, {
    key: "encodedLength",

    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    get: function get() {
      return this.reduce(function (length, entry) {
        length += entry.encodedLength;
        return length;
      }, 0);
    }
    /**
     * @description The types definition of the tuple
     */

  }, {
    key: "Types",
    get: function get() {
      var _this3 = this;

      return Array.isArray(this._Types) ? this._Types.map(function (Type) {
        return new Type(_this3.registry).toRawType();
      }) : Object.keys(this._Types);
    }
  }], [{
    key: "with",
    value: function _with(Types) {
      return (
        /*#__PURE__*/
        function (_Tuple) {
          _inherits(_class, _Tuple);

          function _class(registry, value) {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, registry, Types, value));
          }

          return _class;
        }(Tuple)
      );
    }
  }]);

  return Tuple;
}(AbstractArray);